import Avatar from '@atlaskit/avatar';
import { useUser } from '#definitions/user';

const AtlassianUserIcon = () => {
  const user = useUser();

  return <Avatar size="xxlarge" src={user?.picture} />;
};

export default AtlassianUserIcon;
